import { Button, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	open: boolean;
	title: string;
	description: string;
	confirmLabel: string;
	cancelLabel: string;
	destructive?: boolean;
	isPending?: boolean;
	onConfirm: () => void;
	onClose: () => void;
};

export const ConfirmDrawer: FC<Props> = ({
	open,
	title,
	description,
	confirmLabel,
	cancelLabel,
	destructive,
	isPending,
	onConfirm,
	onClose,
}) => (
	<MyPlannDrawer
		anchor="bottom"
		open={open}
		onClose={isPending ? undefined : onClose}
		title={title}
		closeButton
	>
		<Stack px={2} pb={2} gap={2}>
			<Typography variant="body2">{description}</Typography>
			<Stack gap={1}>
				{destructive ? (
					<Button
						variant="tertiary"
						color="error"
						loading={isPending}
						onClick={onConfirm}
					>
						{confirmLabel}
					</Button>
				) : (
					<Button variant="primary" loading={isPending} onClick={onConfirm}>
						{confirmLabel}
					</Button>
				)}
				<Button variant="tertiary" disabled={isPending} onClick={onClose}>
					{cancelLabel}
				</Button>
			</Stack>
		</Stack>
	</MyPlannDrawer>
);
